import __request__ from "routing/request";
export function updateConfig(JSONbody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.aws/config", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
